import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HelperFunctions, TableFilterPipe } from 'bowman-commons';
import { Subscription } from 'rxjs';
import { ManagementService } from 'src/app/services/management.service';
import { DictionaryService } from '../data-types/dictionary/dictionary.service';
import { ErrorMessage } from '../shared/error-message';
import { ExportDto } from './model/export-dto';
import { ImportJsonRequest } from './model/import-json-request';
import { ImportResponse } from './model/import-response';
import { ImportType } from './model/import-type.enum';
import { ImportZipRequest } from './model/import-zip-request';

@Component({
    templateUrl: './import.component.html',

})
export class ImportComponent implements OnDestroy {

    @Input() type: ImportType;
    @Input()
    public errorMessage: ErrorMessage = new ErrorMessage();
    public form: FormGroup;
    public exportList: Array<ExportDto> = [];
    public fileNameList: Array<string> = [];
    public fileNameCheckedList: Array<string> = [];
    public busy: Subscription;
    public importReport: boolean = false;
    public importReportElements: Array<ImportResponse>;
    public importCompleted: boolean = false;
    get handleExportListModal() { return ImportComponent.handleExportList }
    get fillExportListModal() { return ImportComponent.fillExportList }
    public dictionaryName: string;


    constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private _managementService: ManagementService, private _dictionaryService: DictionaryService) {
        this.createForm();
    }

    closeModal(el: any) {
    }

    // Form File Input
    @ViewChild('fileInput') fileInput: ElementRef;
    public createForm() {
        this.form = this.fb.group({
            content: null
        });
    }
    public submitFile() {
        const formModel = this.form.value;
        if (this.type == ImportType.DICTIONARY_DEFINITION) {
            this.busy = this._dictionaryService.importDefinition(formModel.content).subscribe(res => {
                this.importReport = true;
                this.importReportElements = res.result;
                this.importCompleted = true;
            })
        } else if (this.type == ImportType.DICTIONARY_ELEMENTS) {
            this.busy = this._dictionaryService.saveAsCsv(this.dictionaryName, formModel.content.base64content).subscribe(res => {
                this.importReport = true;
                let importResponse: ImportResponse = new ImportResponse();
                importResponse.name = this.dictionaryName;
                importResponse.status = 'OK';
                this.importReportElements = [importResponse];
                this.importCompleted = true;
            }, err => {
                this.errorMessage = new ErrorMessage('Unable to import dictionary data', err);
            });
        } else {
            if (formModel.content instanceof ImportJsonRequest) {
                this.busy = this._managementService.importJson(formModel.content, ImportType[this.type]).subscribe(res => {
                    this.importReport = true;
                    this.importReportElements = res.result;
                    this.importCompleted = true;
                })
            } else if (formModel.content instanceof ImportZipRequest) {
                this.busy = this._managementService.checkImport(formModel.content).subscribe(res => {
                    if (res.status == 'OK') {
                        res.result.forEach(r => {
                            this.fileNameList.push(r);
                            this.fileNameCheckedList.push(r);
                        });
                        this.form.value.content.fileList = HelperFunctions.cloneObject(this.fileNameCheckedList);
                    } else {
                        this.errorMessage = new ErrorMessage('Unable to import file', res.message);
                    }
                }, err => {
                    this.errorMessage = new ErrorMessage('Unable to import file', err.message);
                })
            }
        }

    }
    public submitZip() {
        this.form.value.content.fileList = HelperFunctions.cloneObject(this.fileNameCheckedList);
        this.busy = this._managementService.importZip(this.form.value.content, ImportType[this.type]).subscribe(res => {
            this.importReport = true;
            this.importReportElements = res.result;
            this.importCompleted = true;
        });
    }
    public onFileChange(event) {
        let reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
            let file = event.target.files[0];
            reader.readAsDataURL(file);
            if (file.type == 'application/json') {
                reader.onload = () => {
                    this.form.get('content').setValue(
                        new ImportJsonRequest((reader.result as string).split(',')[1], file.name)
                    );

                };
            } else if (file.type == 'application/zip') {
                reader.onload = () => {
                    this.form.get('content').setValue(
                        new ImportZipRequest((reader.result as string).split(',')[1], [])
                    );
                };
            } else if (file.type == 'text/csv') {
                reader.onload = () => {
                    this.form.get('content').setValue(
                        new ImportJsonRequest((reader.result as string).split(',')[1], file.name)
                    );

                };
            } else {
                this.errorMessage = new ErrorMessage('Unknown file format', 'The only formats allowed are json, zip and csv.');
            }

        }
    }

    public static exportObjects(exportList: Array<any>, importType: string, _managementService: ManagementService, _dictionaryService?: DictionaryService) {
        if (ImportType[importType] == ImportType.DICTIONARY_ELEMENTS) {
            _dictionaryService.readAsCsv(exportList[0].name).subscribe(res => { }, err => {

            });
        } else {
            let exportListParsed: Array<ExportDto> = [];
            exportList.forEach(obj => {
                exportListParsed.push(new ExportDto(obj, ImportType[importType]));
            });
            if (exportListParsed.length == 1) {
                _managementService.exportSingle(exportListParsed[0], importType);
                // Export singolo
            } else if (exportListParsed.length > 1) {
                _managementService.export(exportListParsed, importType).subscribe(res => {
                    return res;
                });
            }
        }

    }
    public static handleExportList(selectedElement: any, exportList: Array<any>) {
        let index = exportList.indexOf(selectedElement);
        if (index == -1) {
            exportList.push(selectedElement);
        } else {
            exportList.splice(index, 1);
        }
    }
    public static fillExportList(event: any, exportList: Array<any>, elements: Array<any>, searchText?: string, tableFilterPipe?: TableFilterPipe) {
        if (tableFilterPipe) {
            elements = tableFilterPipe.transform(elements, searchText);
        }
        HelperFunctions.uniqueBy(exportList, function (x) {
            if (x && x.id) {
                return x.id;
            }
        })

        if (event && event.target && event.target['checked'] && !event.target['disabled']) {
            elements.forEach(el => {
                if (el.name) {
                    if (el.name !== 'admin') {
                        exportList.push(el);
                    }
                } else {
                    exportList.push(el);
                }
            })
        } else if (event && event.target && !event.target['checked']) {

            elements.forEach(el => {
                let index = exportList.indexOf(el);
                exportList.splice(index, 1);
            });
        }
    }


    ngOnDestroy(): void {
        this.form.reset();
    }
}